import React, { useContext } from 'react'
import Loader from '@components/Feedback/Loader'
import TableContext from '@components/Common/Table/context'
import TableColumn from '../Container/Column'

const TableLoader: React.FC = () => {

    const { columns, omitColumns } = useContext(TableContext)

    return(

        <tr>
            <TableColumn className = "center" colSpan = {columns.length - omitColumns.length}>
                <Loader />
            </TableColumn>
        </tr>

    )

}

export default TableLoader